import { Component, forwardRef, OnDestroy, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  NG_VALIDATORS
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { BaseDynamicForm } from 'src/app/core/services/base-dynamic-form';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { UtilsService } from 'src/app/core/services/utils.service';

export interface ProfileStreetPostalAddress {

  Country: string;
  CountryPostal: string;
  MunicipioPostal: string;
  PPostalCode: string;
  PostPlusFour1: string;
  PostPlusFour2: string;
  PostalAddress: string;
  PostalAddress2: string;
  PostalCode: string;
  CityPostal: string;
  StatePostal: string;

  StreetAddress: string;
  StreetAddress2: string;
  postalAsStreet: string;

  MunicipioStreet: string;
  State: string;
  City: string;
}

@Component({
  selector: 'app-street-postal-address-form',
  templateUrl: './street-postal-address-form.component.html',
  styleUrls: ['./street-postal-address-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StreetPostalAddressFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => StreetPostalAddressFormComponent),
      multi: true,
    }
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreetPostalAddressFormComponent extends BaseDynamicForm implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() isRequired = false;

  @Input() street = true;
  @Input() showHeaders = true;
  @Input() managePostal = true;
  @Input() solicitant: any = '';
  @Input() enableCopy = true;
  @Input() titlePhysicalAddress = '';
  @Input() titlePostalAddress = '';
  form: FormGroup;
  subscriptions: Subscription[] = [];

  get value(): ProfileStreetPostalAddress {
    console.log('this.form.value');
    console.log(this.form.value);
    return this.form.value;
  }

  set value(value: ProfileStreetPostalAddress) {
    this.form.patchValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(
    private formBuilder: FormBuilder, public ls: LsHelperService,
    public dynamicFormService: DynamicFormService,
    public lookupService: LookupService,
    private matSnackBar: MatSnackBar) {
    super();

    this.form = this.formBuilder.group({
      StreetAddress: [{ value: '', disabled: this.dynamicFormService.isReadOnly }, Validators.required],
      StreetAddress2: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      Country: [{ value: '', disabled: this.dynamicFormService.isReadOnly }, Validators.required],
      MunicipioStreet: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      City: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      State: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      PostalCode: [{ value: '', disabled: this.dynamicFormService.isReadOnly }, Validators.required],
      PostPlusFour1: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      postalAsStreet: [{ value: false, disabled: this.dynamicFormService.isReadOnly }],

      PostalAddress: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      PostalAddress2: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      CountryPostal: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      MunicipioPostal: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      CityPostal: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      StatePostal: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      PPostalCode: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
      PostPlusFour2: [{ value: '', disabled: this.dynamicFormService.isReadOnly }],
    });

    this.subscriptions.push(
      this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );


    this.form.controls.StreetAddress.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });
    this.form.controls.MunicipioStreet.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });
    this.form.controls.StreetAddress2.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });
    this.form.controls.PostalCode.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });
    this.form.controls.PostPlusFour1.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });

    this.form.controls.Country.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
      this.onCountryChange('City', 'State', 'MunicipioStreet', val);
    });
    this.form.controls.State.valueChanges.subscribe((val) => {
      this.patchSameAsPhysical();
    });

    if (this.lookupService.cities.length === 0) {
      this.lookupService.getLookups();
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  validate(formControl: FormControl) {
    let returnValue = null;

    if (!this.form.valid) {
      returnValue = { profile: { valid: false } };
    }

    console.log(this.form.valid);

    return returnValue;
  }

  patchSameAsPhysical() {
    if (this.form.controls.postalAsStreet.value === true) {
      // console.log('same!');
      this.form.patchValue({
        PostalAddress: this.form.controls.StreetAddress.value,
        PostalAddress2: this.form.controls.StreetAddress2.value,
        PPostalCode: this.form.controls.PostalCode.value,
        PostPlusFour2: this.form.controls.PostPlusFour1.value,
      });
      this.form.controls.MunicipioPostal.setValue(this.form.controls.MunicipioStreet.value);
      this.form.controls.CountryPostal.setValue(this.form.controls.Country.value);
      this.form.controls.StatePostal.setValue(this.form.controls.State.value);
      this.form.controls.CityPostal.setValue(this.form.controls.City.value);
      this.form.controls.CityPostal.setValue(this.form.controls.Country.value);
      this.form.updateValueAndValidity();

    } else {
      this.form.patchValue({
        PostalAddress: '',
        PostalAddress2: '',
        MunicipioPostal: '',
        CountryPostal: '',
        StatePostal: '',
        CityPostal: '',
        PPostalCode: '',
        PostPlusFour2: '',
      });
    }

  }


  public streetPostalCheck(control, prefix = '', fg = 'form'): void {


    if (control.checked) { // Se pasó a mat-checkbox
      this.disablePostal(prefix, fg);
    } else {
      this.enablePostal(prefix, fg);
    }
    this[fg].updateValueAndValidity();
  }

  public disablePostal(prefix, fg): void {
    this[fg].controls[prefix + 'PostalAddress'].disable();
    this[fg].controls[prefix + 'PostalAddress2'].disable();
    this[fg].controls[prefix + 'MunicipioPostal'].disable();
    this[fg].controls[prefix + 'StatePostal'].disable();
    this[fg].controls[prefix + 'CityPostal'].disable();
    this[fg].controls[prefix + 'CountryPostal'].disable();
    // [fg].controls[ prefix + 'PostalCountry'].disable();
    this[fg].controls[prefix + 'PPostalCode'].disable();
  }

  public enablePostal(prefix, fg): void {

    this[fg].controls[prefix + 'PostalAddress'].enable();
    this[fg].controls[prefix + 'PostalAddress2'].enable();
    this[fg].controls[prefix + 'MunicipioPostal'].enable();
    this[fg].controls[prefix + 'StatePostal'].enable();
    this[fg].controls[prefix + 'CityPostal'].enable();
    this[fg].controls[prefix + 'CountryPostal'].enable();
    // this[fg].controls[ prefix + 'PostalCountry'].enable();
    this[fg].controls[prefix + 'PPostalCode'].enable();

  }

  onCountryChange(city, state, municipality, value) {
    switch (value) {
      case '376':
        this.form.controls[municipality].enable();
        this.form.controls[municipality].setValidators(Validators.required);

        this.form.controls[city].clearValidators();
        this.form.controls[city].disable();
        this.form.controls[city].patchValue('');

        this.form.controls[state].clearValidators();
        this.form.controls[state].disable();
        this.form.controls[state].patchValue('');
        break;

      case '113':
        this.form.controls[city].enable();
        this.form.controls[city].setValidators(Validators.required);

        this.form.controls[state].enable();
        this.form.controls[state].setValidators(Validators.required);

        this.form.controls[municipality].clearValidators();
        this.form.controls[municipality].disable();
        this.form.controls[municipality].patchValue('');
        break;

      default:
        this.form.controls[municipality].clearValidators();
        this.form.controls[municipality].disable();
        this.form.controls[municipality].patchValue('');

        this.form.controls[state].clearValidators();
        this.form.controls[state].disable();
        this.form.controls[state].patchValue('');

        this.form.controls[city].clearValidators();
        this.form.controls[city].disable();
        this.form.controls[city].patchValue('');
        break;
    }

    this.form.controls[municipality].updateValueAndValidity();
    this.form.controls[city].updateValueAndValidity();
    this.form.controls[state].updateValueAndValidity();

  }

  printFormValidation() {
    const utils = new UtilsService();

    console.log(utils.findInvalidControls(this.form));
  }

  copy() {

    const countryId = this.form.controls.CountryPostal.value;
    const stateId = this.form.controls.StatePostal.value;
    const municipioId = this.form.controls.MunicipioPostal.value;

    const country = this.lookupService.countries.filter(function(e) {
      return e.value === countryId;
    });

    const state = this.lookupService.states.filter(function(e) {
      return e.value === stateId;
    });

    const municipio = this.lookupService.cities.filter(function(e) {
      return e.value === municipioId;
    });

    const textarea = (this.solicitant ? (this.solicitant.FirstName + (this.solicitant.MiddleName ? (' ' + this.solicitant.MiddleName + ' ') : ' ') + this.solicitant.FirstLastName + ' ' + this.solicitant.SecondLastName + '\n') : '')
      + this.form.controls.PostalAddress.value + '\n'
      + (this.form.controls.PostalAddress2.value ? (this.form.controls.PostalAddress2.value + '\n') : '')
      + (municipio[0] ? (municipio[0].label + ', ') : '')
      + (this.form.controls.CityPostal.value ? (this.form.controls.CityPostal.value + ', ') : '')
      + (state[0] ? (state[0].label + ', ') : '')
      + (country[0] ? (country[0].label + '\n') : '')
      + this.form.controls.PPostalCode.value
      + (this.form.controls.PostPlusFour2.value ? ('-' + this.form.controls.PostPlusFour2.value) : '');
    const element = document.createElement('TEXTAREA') as HTMLTextAreaElement;
    element.value = textarea;
    document.body.appendChild(element);
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);
  }

  getForm(): FormGroup {
    return this.form;
  }
}
